import Icon from "../../../Icon";
import { Platform, StyleSheet, View } from "react-native";
import { RectangleBlur } from "./components/RectangleBlur";
import MaskedView from "@react-native-masked-view/masked-view";
import HStack from "../../../../ui_atoms/HStack";
import { useMemo } from "react";
import { useTheme } from "../../../../hooks/use-theme";
import { TitleMediumText } from "../../../FormattedText";
import VStack from "../../../../ui_atoms/VStack";
import { RECTANGLE_SIZES_MAP, RectangleViewProps } from "./data";
import { DropShadow } from "../../../DropShadow";

export const Rectangle = ({ icons = [], title, description, style }: RectangleViewProps) => {
    const styles = useStyles();
    const { colors } = useTheme();

    const config = RECTANGLE_SIZES_MAP[icons.length];

    return (
        <View
            style={[
                style,
                {
                    width: config.rectWidth,
                    height: config.rectHeight,
                    alignItems: "center",
                    justifyContent: "center",
                },
            ]}
        >
            <RectangleBlur
                headerSize={
                    icons?.length === 1 ? "small" : icons?.length === 2 ? "large" : undefined
                }
                MaskComponent={config.MaskComponent}
            />
            <MaskedView
                maskElement={config.shadowMaskComponentElement}
                style={{
                    width: config.shadowWidth,
                    height: config.shadowHeight,
                    position: "absolute",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: Platform.OS === "web" ? 100 : undefined, // fix for correctly display drop shadows on web
                }}
            >
                <DropShadow
                    shadowLevel={16}
                    shadowOpacity={0.2}
                    style={{
                        width: config.rectWidth,
                        height: config.rectHeight,
                    }}
                >
                    <config.MaskComponent style={StyleSheet.absoluteFill} />
                </DropShadow>
            </MaskedView>
            <VStack gap="1/3" style={styles.contentContainer}>
                {icons.length > 0 ? (
                    <HStack gap="1/3">
                        {icons.map((icon, index) => (
                            <Icon key={index} size={32} color={colors.secondary} name={icon} />
                        ))}
                    </HStack>
                ) : null}
                {title ? <TitleMediumText color={colors.secondary}>{title}</TitleMediumText> : null}
                {description}
            </VStack>
        </View>
    );
};

const PADDING = 12;

const useStyles = () => {
    return useMemo(
        () =>
            StyleSheet.create({
                contentContainer: {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    padding: PADDING,
                },
            }),
        [],
    );
};
